/* eslint-disable react/prop-types */
import {useContext, useState} from 'react'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import LeadPhoneCall, {leadPhoneCallSizes, leadPhoneCallTarget} from '@adv-mt/mt-lead-phone-call'
import TitleBasic, {titleBasicSizes, titleBasicTextAlign} from '@adv-mt/mt-title-basic'

const CardAdContactSeller = ({ad, backgroundImage}) => {
  const {domain} = useContext(Context)

  const [leadData, setLeadData] = useState()

  useMount(async () => {
    const [, _leadData] = await domain
      .get('get_lead_data_tracking_use_case')
      .execute({ad, dealerId: ad?.seller?.contractId})
    setLeadData(_leadData)
  })

  return (
    <div className="mt-CardAd-mediaContactSellerWrapper">
      {backgroundImage && (
        <div className="mt-CardAd-mediaContactSellerImageWrapper">
          <img alt={backgroundImage.title} className="mt-CardAd-mediaContactSellerImage" src={backgroundImage.src} />
        </div>
      )}
      <div className="mt-CardAd-mediaContactSeller">
        <div className="mt-CardAd-mediaContactSellerTitle">
          <TitleBasic
            description="Contacta ahora con el anunciante"
            size={titleBasicSizes.m}
            textAlign={titleBasicTextAlign.center}
            title="¿Te gusta?"
          />
        </div>
        <div className="mt-CardAd-mediaContactSellerButtonWrapper">
          <div className="mt-CardAd-mediaContactSellerButton">
            <LeadPhoneCall
              adId={ad.id}
              extendedLeadTrackingData={leadData}
              isProfessionalDealer={ad.isProfessional}
              phone={ad.phone}
              size={leadPhoneCallSizes.large}
              target={leadPhoneCallTarget.imageGallery}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardAdContactSeller
